import { useTranslation } from 'react-i18next'

import { CustomConfirmDialog } from '../../../../../../components/dialogs'

type Props = {
  onClickHandler: () => void
  isVisible: boolean
  onHide: () => void
  count: number
}

export const DeleteAssignees: React.FC<Props> = ({
  onClickHandler,
  isVisible,
  onHide,
  count,
}) => {
  const { t } = useTranslation()

  const message = (
    <>
      <p>
        {t('roleAssignments.table.delete.dialogAssignees.description', {
          count: count,
        })}
      </p>
    </>
  )
  return (
    <CustomConfirmDialog
      severity="danger"
      isVisible={isVisible}
      header={t('roleAssignments.table.delete.dialogAssignees.title')}
      message={message}
      onHide={onHide}
      onReject={onHide}
      rejectLabel={t(
        'roleAssignments.table.delete.dialogAssignees.cancel.label',
      )}
      onAccept={onClickHandler}
      acceptLabel={t(
        'roleAssignments.table.delete.dialogAssignees.delete.label',
      )}
    />
  )
}
